// A back control on every page but the homepage.
//
// Most visits arrive from a shared link — WhatsApp, a search result — with no
// history behind them, so the browser's own back button is dead and the only
// way out is the menu. This goes back when there is somewhere to go back to,
// and otherwise walks up one level: a character page to the archive, an arc to
// the list of arcs, anything else to the games.

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './BackButton.css';

// Where a page sits, so "up" means something on a first visit.
const parentOf = (pathname) => {
  if (pathname.startsWith('/characters/')) return '/characters';
  if (pathname.startsWith('/arcs/')) return '/arcs';
  if (pathname.startsWith('/guides/')) return '/guides';
  return '/';
};

const BackButton = ({ variant = "header" }) => {
  const navigate = useNavigate();
  const { pathname, key } = useLocation();

  if (pathname === '/') return null;

  // key is 'default' on the first entry of a session: nothing to go back to
  // inside the site, so the button climbs instead of trapping the visitor.
  const canGoBack = key !== 'default' && window.history.length > 1;
  const parent = parentOf(pathname);
  const label = canGoBack ? 'Back' : parent === '/' ? 'Back to the games' : 'Back';

  return (
    <div className={`back-row back-row-${variant}`}>
      <button
        type="button"
        className="back-button"
        onClick={() => (canGoBack ? navigate(-1) : navigate(parent))}
      >
        <span className="back-button-arrow" aria-hidden="true">←</span>
        <span className="back-button-label">{label}</span>
      </button>
    </div>
  );
};

export default BackButton;
